import axios from 'axios';
import useStore from './store';

/**
 * Instancia central de axios para el backend de Amanda.
 *
 * - baseURL: se toma de REACT_APP_API_URL (definida en `.env`, resuelta en
 *   build por CRA) con fallback a producción.
 * - Interceptor de request: inyecta `Authorization: Bearer <authToken>` desde
 *   el store (Zustand, token en memoria) SOLO si la llamada no trae ya un
 *   header Authorization propio. Flujos sin ese header (portal de candidatos
 *   con `x-candidate-token`, pantallas públicas sin sesión) no se ven
 *   afectados porque sin token en el store no se agrega nada.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.amandahr.ai/api',
});

api.interceptors.request.use((config) => {
  const { authToken } = useStore.getState();
  if (!authToken) return config;

  const headers = config.headers || {};
  const hasAuth =
    typeof headers.has === 'function'
      ? headers.has('Authorization')
      : Boolean(headers.Authorization || headers.authorization);

  if (!hasAuth) {
    if (typeof headers.set === 'function') {
      headers.set('Authorization', `Bearer ${authToken}`);
    } else {
      headers.Authorization = `Bearer ${authToken}`;
    }
    config.headers = headers;
  }
  return config;
});

export default api;
